"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderFooter = exports.EXTENDED_STORY_INCLUDED_EXTRA_FIELDS = exports.Appearance = exports.Alignment = exports.ALL_EXTRA_FIELDS = void 0;
var _index = require("../../types/index.cjs");
/**
 * Uploadcare image JSON string.
 */

/**
 * Raw HTML string.
 */

/**
 * String-serialized JSON object.
 */

/**
 * String containing Prezly Content Format JSON structure.
 */

const Alignment = exports.Alignment = _index.Campaign.StoryAlignment;
const Appearance = exports.Appearance = _index.Campaign.StoryAppearance;
const HeaderFooter = exports.HeaderFooter = _index.Campaign.StoryHeaderFooter;
const EXTENDED_STORY_INCLUDED_EXTRA_FIELDS_SHAPE = {
  thumbnail_image: true,
  header_image: true,
  preview_image: true,
  social_image: true,
  social_text: true,
  tag_names: true,
  content: true,
  attached_gallery_content: true,
  referenced_entities: true
}; // satisfies Record<keyof Omit<ExtendedStory, keyof Story>, boolean>; // TODO: Use Typescript `satisfies` operator, when it's out of beta

const ALL_EXTRA_FIELDS_SHAPE = {
  thumbnail_image: true,
  header_image: true,
  preview_image: true,
  social_image: true,
  social_text: true,
  tag_names: true,
  content: true,
  autosaved_content: true,
  content_version: true,
  last_modifying_user: true,
  attached_gallery_content: true,
  attached_videos_content: true,
  attached_bookmarks_content: true,
  attached_attachments_content: true,
  attached_contacts_content: true,
  referenced_entities: true,
  'campaigns.count': true,
  'pitches.count': true
}; // satisfies Record<keyof Story.OnDemandFields, boolean>; // TODO: Use Typescript `satisfies` operator, when it's out of beta

const ALL_EXTRA_FIELDS = exports.ALL_EXTRA_FIELDS = Object.keys(ALL_EXTRA_FIELDS_SHAPE);
const EXTENDED_STORY_INCLUDED_EXTRA_FIELDS = exports.EXTENDED_STORY_INCLUDED_EXTRA_FIELDS = Object.keys(EXTENDED_STORY_INCLUDED_EXTRA_FIELDS_SHAPE);